"use client";
import { HolidaysSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";

const Holidays: FC<HolidaysSectionProps> = () => {
  return (
    <h3
      style={{
        backgroundColor: "black",
        color: "white",
        textAlign: "center",
        padding: 50,
      }}
    >
      Holidays
    </h3>
  );
};

export default Holidays;
